/**
 * Withdrawal Stats Cards Component
 */
import React from 'react';
import { Card, CardContent } from '../../ui/card';
import { DollarSign, Clock, CheckCircle, XCircle, ArrowUpRight, ArrowDownRight } from 'lucide-react';

const StatCard = ({ title, value, icon: Icon, trend, trendUp, color = 'text-white' }) => (
  <Card className="bg-gray-800/50 border-gray-700">
    <CardContent className="p-4">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-gray-400 text-sm">{title}</p>
          <p className={`text-2xl font-bold ${color}`}>{value}</p>
          {trend && (
            <div className={`flex items-center text-sm mt-1 ${trendUp ? 'text-green-400' : 'text-red-400'}`}>
              {trendUp ? <ArrowUpRight className="w-4 h-4" /> : <ArrowDownRight className="w-4 h-4" />}
              <span>{trend}</span>
            </div>
          )}
        </div>
        <div className={`p-3 rounded-lg ${color === 'text-yellow-400' ? 'bg-yellow-500/20' : color === 'text-green-400' ? 'bg-green-500/20' : color === 'text-red-400' ? 'bg-red-500/20' : 'bg-gray-700'}`}>
          <Icon className={`w-6 h-6 ${color}`} />
        </div>
      </div>
    </CardContent>
  </Card>
);

export const WithdrawalStats = ({ stats }) => {
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(amount || 0);
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 mb-6">
      <StatCard
        title="Total Withdrawals"
        value={stats.total || 0}
        icon={DollarSign}
        color="text-white"
      />
      <StatCard
        title="Pending"
        value={stats.pending || 0}
        icon={Clock}
        color="text-yellow-400"
      />
      <StatCard
        title="Approved"
        value={stats.approved || 0}
        icon={CheckCircle}
        color="text-blue-400"
      />
      <StatCard
        title="Completed"
        value={stats.completed || 0}
        icon={CheckCircle}
        color="text-green-400"
      />
      <StatCard
        title="Total Amount"
        value={formatCurrency(stats.total_amount)}
        icon={DollarSign}
        color="text-purple-400"
      />
    </div>
  );
};

export default WithdrawalStats;
